import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileOrganization } from "../../../store/attendance/actions/getUserProfileOrganization";
import {getSync} from "../../../store/attendance/actions/getSync";
import {RootState} from "../../../store/rootReducer";


interface Organization {
  id: string;
  name: string;
}

interface Props {
  onChange: (organizationId: string) => void;
  interfaceOptions?: { cssClass: string }; // <--- CAMBIO de string[] a string
}

const OrganizationSelector = ({  onChange, interfaceOptions }: Props) => {
  const userId = useSelector((state: RootState) => state.userAuthentication.user?.id);

  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [selectedOrgId, setSelectedOrgId] = useState<string>("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userId) return; // <-- evita continuar si no hay userId
    const fetchOrganizations = async () => {
      const result = await dispatch(getUserProfileOrganization(userId));
      console.log(result)

      const orgs = (result as any).payload as Organization[];
      if (Array.isArray(orgs)) {
        setOrganizations(orgs);
      }
    };
    fetchOrganizations();

  }, [userId]);

  const handleChange = (value: string) => {
    setSelectedOrgId(value);
    onChange(value);
  };

  return (
    <IonItem lines="inset">
      <IonLabel position="stacked">Organización</IonLabel>
      <IonSelect
        interfaceOptions={interfaceOptions}
        value={selectedOrgId}
        placeholder="Seleccionar organización"
        okText="Aceptar"
        cancelText="Cancelar"
        onIonChange={(e) => handleChange(e.detail.value)}
      >
        {organizations.map(org => (
          <IonSelectOption key={org.id} value={org.id}>
            {org.name}
          </IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  );
};

export default OrganizationSelector;
